<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">     
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 有效期">
            <a-range-picker :showTime="{defaultValue:showTimeDefault}"
            :disabledDate="disabledDate" v-decorator="[
          'rangeTime',
          {initialValue:data.rangeTime,rules: [{ required: true, message: '请选择有效期' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>    
      
      <div class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { fail } from "assert";
const defaultData = {
  startTime: null,
  rangeTime: null,
  endTime: null,
};
export default {
  name: "hp-manager-page-set-product",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    paramsS: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      
      showTimeDefault: [new moment({ h: 0, m: 0, s: 0, ms: 0 }), new moment({ h: 23, m: 59, s: 59, ms: 0 })],
    };
  },

  async mounted() {
    this.data = exzends(defaultData);
    console.log(this.paramsS);
  },

  methods: {        
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },    
    cancel() {
      this.$emit("cancel");
    },
    async submitHandler() {
      await api.SetProductIsActivity(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.paramsS.id,
        startTime: value.rangeTime[0].valueOf(),
        endTime: value.rangeTime[1].valueOf(),        
      };
      console.log(result);
      return result;
    },
    dataToPostDataForBatch(value) {
      let result = {
        ProductIdList:this.paramsS.productIdList,
        startTime: value.rangeTime[0].valueOf(),
        endTime: value.rangeTime[1].valueOf(),        
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        if(this.paramsS.type==1||this.paramsS.type==2){
        let requestData = this.dataToPostData(valid.values);           
        if (this.paramsS.type==1) {
          data = await api.SetProductIsActivity(requestData);
          if (data) {
            this.$message.success("操作成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.SetProductIsNew(requestData);
          if (data) {
            this.$message.success("操作成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
        }
        if(this.paramsS.type>2){
        let requestData = this.dataToPostDataForBatch(valid.values);      
          
        if (this.paramsS.type==3) {
          data = await api.BatchSetActivityProduct(requestData);
          if (data) {
            this.$message.success("操作成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.BatchSetNewProduct(requestData);
          if (data) {
            this.$message.success("操作成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
        }

      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/Product/SetProduct.vue